import '../components/home/home.css';
import Navbar              from '../components/home/Navbar';
import HeroSlider          from '../components/home/HeroSlider';
import ContactBar          from '../components/home/ContactBar';
import AboutSection        from '../components/home/AboutSection';
import SpecialitiesSection from '../components/home/SpecialitiesSection';
import PublicationsSection from '../components/home/PublicationsSection';
import VideoSection        from '../components/home/VideoSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import StudentsJoinSection from '../components/home/StudentsJoinSection';
import Footer              from '../components/home/Footer';

export default function HomePage() {
  return (
    <div className="sa-page">
      <Navbar />

      {/* Slider wrapper: position:relative so ContactBar sits on top of image */}
      <div className="sa-slider-wrapper">
        <HeroSlider />
        <ContactBar />
      </div>

      <AboutSection />
      <SpecialitiesSection />
      <PublicationsSection />
      <VideoSection />
      <TestimonialsSection />
      <StudentsJoinSection />
      <Footer />
    </div>
  );
}
